import { types } from "../types";

const MenuAction = {
    setMenuSelection: () => {
        return { type: types.SET_MENU_SELECTION };
    }
};

export default MenuAction;
